import LeaderProfile from './LeaderProfile'

export default LeaderProfile
